export enum XDEFIBitcoinPayloadMethods {
  REQUEST_ACCOUNTS,
  SIGN_TRANSACTION,
  GET_UNSPENT_UTXOS,
  TRANSFER,
}

export type XDEFIBitcoinPayload = {
  id: number
  method: XDEFIBitcoinPayloadMethods
  params: Array<void | any>
}

export type IMessage = {
  chainInfo: {
    chainId: number | string
    network: string // mainnet testnet for MVP
    other?: any
  }
  namespace: MessageNamespace
  origin: any
  raw: any
  time: number
  xdefiId: number
}

export enum MessageNamespace {
  BINANCEDEX,
  BINANCESMARTCHAIN,
  BITCOIN,
  ETHEREUM,
}
